export enum IconType {
    PLAY = 'pbi-play',
    REPLAY = 'pbi-refresh',
    PAUSE = 'pbi-pause'
}
